import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button } from "antd";

import Swal from "sweetalert2";

import { setUser } from "../../redux/store/auth/authDuck";
import BankListComponent from "../common/BankListComponent";
import PersonalAuthentication from "../common/PersonalAuthentication";

const LandingTogetherComponent = () => {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	const history = useHistory();
	const [certifiedData, setCertifiedData] = useState({}); // 인증 데이터
	const [submitBank, setSubmitBank] = useState({
		bank_code: "",
		account_number: "",
	});

	const validTogetherSignUp =
		!!certifiedData?.is_certified &&
		!!submitBank?.bank_code &&
		!!submitBank?.account_number?.length > 0;

	const handleTogetherSignup = async () => {
		if (validTogetherSignUp) {
			dispatch(
				setUser({
					...user,
					is_influencer: true,
				})
			);
			Swal.fire({
				customClass: "alert-custom",
				text: `환영합니다!`,
				confirmButtonText: "확인",
				// confirmButtonColor: "#212529",
			}).then(() => {
				history.replace("/dashboard");
			});
		} else {
			if (!certifiedData?.is_certified) {
				Swal.fire({
					customClass: "alert-custom",
					text: `본인인증을 진행해주세요.`,
					confirmButtonText: "확인",
					// confirmButtonColor: "#212529",
				});
			} else if (
				!submitBank?.bank_code &&
				!submitBank?.account_number?.length > 0
			) {
				Swal.fire({
					customClass: "alert-custom",
					text: `계좌를 입력해주세요.`,
					confirmButtonText: "확인",
					// confirmButtonColor: "#212529",
				});
			}
		}
	};

	useEffect(() => {
		if (user?.id) {
			setCertifiedData({
				is_certified: !!user.is_certified,
			});
			setSubmitBank({
				bank_code: user.bank_code,
				account_number: user.account_number,
			});
		}
	}, [user]);

	return (
		<div className="main-wrap">
			<div className={`max-width-apply`}>
				<div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
					{/*<PersonalAuthentication*/}
					{/*	certifiedData={certifiedData}*/}
					{/*	setCertifiedData={setCertifiedData}*/}
					{/*/>*/}
					<BankListComponent
						submitBank={submitBank}
						setSubmitBank={setSubmitBank}
					/>
					<Button
						onClick={handleTogetherSignup}
						disabled={!validTogetherSignUp}
					>
						가입하기
					</Button>
				</div>
			</div>
		</div>
	);
};

export default LandingTogetherComponent;
